import { render } from "./crm-segments.vue?vue&type=template&id=7a9f8ed9&scoped=true"
import script from "./crm-segments.vue?vue&type=script&lang=js"
export * from "./crm-segments.vue?vue&type=script&lang=js"

import "./crm-segments.vue?vue&type=style&index=0&id=7a9f8ed9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a9f8ed9"]])

export default __exports__